<template>
  <div id="users" v-if="showWindow">
    <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :filters="filters"
      >
    </table-view>
  </div>
</template>

<script>

import tableView from '../../components/tableView';
export default {
  components: {   
    tableView
  },
  data() {
    
    let data = {
      params:{},
      endPoint:'users',
      filters: {disable: true},
      columnDefs: [
        {
          headerName: 'agent',
          field: 'agent',          
          filter: true,
          action: 'showUser',
          cellStyle: {color: 'blue'},
          width: 125,
        },
        {
          headerName: 'User Name',
          field: 'username',
          filter: true,          
          width: 175,
        },
        {
          headerName: 'Email',
          field: 'email',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Risk group',
          field: 'risk_group',
          filter: true,
          width: 250,
        },        
        {
          headerName: 'Delete',
          field:'deleteUser',
          action: 'deleteUser',
          filter: false,
          cellStyle: {color: 'red'},
          cellRenderer: function() {
            return 'Delete';
          }
        }
      ],
    }    
    return data;
  },
  computed: {
    showWindow(){
      if(this.$route.path==='/settings/users'){
        return true;
      }
      return false;
    },
  },
  mounted() {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
  }
}

</script>
/